<template>
  <div class="h-100 d-flex flex-column align-items-center justify-content-center pt-5">
    <b-card>
      <b-img
        class="mb-2 pb-3 border-bottom"
        width="225"
        :src="require('../assets/seaway_logo.png')"
      ></b-img>
      <p class="h5 mb-3 text-center font-weight-bold">Password Reset</p>
      <!-- email form -->
      <div
        id="forgot-password-email-form"
        class="flex-column"
        :class="[forgotPasswordEmail ? 'd-flex': 'd-none']"
      >
        <div>
          <label for="forgot-password-email">Enter email:</label>
          <b-form-input
            id="forgot-password-email"
            v-model="email"
            type="email"
            placeholder="john@email.com.."
          ></b-form-input>
        </div>
        <div class="align-self-end m-3">
          <b-button to="/" @click="exit" class="m-1" variant="secondary">Cancel</b-button>
          <b-button class="m-1" @click="submitEmail" variant="primary">Continue</b-button>
        </div>
      </div>
      <!-- token form -->
      <div
        id="forgot-password-token-form"
        class="flex-column"
        :class="[forgotPasswordToken ? 'd-flex': 'd-none']"
      >
        <div>
          <p
            class="text-secondary"
            style="width:225px"
          >5 digit token has been sent to your email. please allow 3-5 minutes..</p>
          <label for="forgot-password-token">Enter Token:</label>
          <b-form-input
            id="forgot-password-token"
            v-model="token"
            type="email"
            placeholder="12345.."
          ></b-form-input>
        </div>
        <div class="align-self-end m-3">
          <b-button to="/" @click="exit" class="m-1" variant="secondary">Cancel</b-button>
          <b-button class="m-1" @click="submitToken" variant="primary">Continue</b-button>
        </div>
      </div>
      <!-- new password form -->
      <div
        id="forgot-password-new-password-form"
        class="flex-column"
        :class="[forgotPasswordNew ? 'd-flex': 'd-none']"
      >
        <div>
          <label for="forgot-password-new-password">Enter new password:</label>
          <b-form-input
            id="forgot-password-new-password"
            type="password"
            v-model="password"
            placeholder="Min 8 digits.."
          ></b-form-input>
        </div>
        <div>
          <label for="forgot-password-confirm-new-password">Confirm new password:</label>
          <b-form-input
            id="forgot-password-confirm-new-password"
            type="password"
            placeholder="Min 8 digits.."
          ></b-form-input>
        </div>
        <div class="align-self-end m-3">
          <b-button to="/" @click="exit" class="m-1" variant="secondary">Cancel</b-button>
          <b-button class="m-1" @click="submitNewPassword" variant="primary">Submit</b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { PasswordResetDisplayState } from "@/store/app";
export default {
  name: "forgot-password",
  data() {
    return {
      email: "",
      token: "",
      password: ""
    };
  },
  methods: {
    submitEmail() {
      this.$store.dispatch("app/requestToken", { email: this.$data.email });
    },
    submitToken() {
      this.$store.dispatch("app/validateToken", { token: this.$data.token });
    },
    submitNewPassword() {
      this.$store
        .dispatch("app/requestNewPassword", {
          password: this.$data.password
        })
        .then(() => {
          this.$router.push("/");
        });
    },
    exit() {
      this.$store.commit("app/RESET_APP");
    }
  },
  computed: {
    forgotPasswordEmail() {
      return (
        this.$store.state.app.passwordResetDisplayStatus ==
        PasswordResetDisplayState.EMAIL
      );
    },
    forgotPasswordToken() {
      return (
        this.$store.state.app.passwordResetDisplayStatus ==
        PasswordResetDisplayState.TOKEN
      );
    },
    forgotPasswordNew() {
      return (
        this.$store.state.app.passwordResetDisplayStatus ==
        PasswordResetDisplayState.PASSWORD
      );
    }
  }
};
</script>
